/** Standard exterior colors for listing create/edit forms. */
export const EXTERIOR_COLORS = [
  "Black",
  "White",
  "Silver",
  "Gray",
  "Red",
  "Blue",
  "Navy Blue",
  "Green",
  "Brown",
  "Beige",
  "Gold",
  "Orange",
  "Yellow",
  "Purple",
  "Burgundy",
  "Other",
] as const;

/** Standard interior colors for listing create/edit forms. */
export const INTERIOR_COLORS = [
  "Black",
  "Gray",
  "Tan",
  "Beige",
  "Brown",
  "White",
  "Red",
  "Blue",
  "Other",
] as const;

export type ExteriorColor = (typeof EXTERIOR_COLORS)[number];
export type InteriorColor = (typeof INTERIOR_COLORS)[number];

/** Case-insensitive match against a standard color list; returns the canonical casing. */
export function matchStandardColor(
  list: readonly string[],
  value: string | null | undefined
): string | null {
  if (!value) return null;
  const hit = list.find((c) => c.toLowerCase() === value.toLowerCase());
  return hit ?? null;
}

/**
 * True when the provider color is a manufacturer-specific name that is not
 * already one of our standard dropdown options (e.g. "Midnight Black Metallic").
 */
export function isOemSpecificColor(
  list: readonly string[],
  value: string | null | undefined
): boolean {
  if (!value?.trim()) return false;
  return matchStandardColor(list, value) === null;
}

/**
 * Prefer the canonical standard color when the provider name matches one;
 * otherwise keep the OEM string so we can show it as a VIN suggestion.
 */
export function resolveColorFromProvider(
  list: readonly string[],
  providerColor: string | null | undefined
): string {
  if (!providerColor?.trim()) return "";
  return matchStandardColor(list, providerColor) ?? providerColor.trim();
}
